import { isEqual } from 'lodash';
export default function createObserver(selector, initialData, handler) {
    var data = initialData;
    return function (nextState, dispatch) {
        var newData = selector(nextState);
        if (!isEqual(data, newData)) {
            handler(data, newData, dispatch);
            data = newData;
        }
    };
}
//# sourceMappingURL=createObserver.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lifesize/web-clients-core/dist/es5-module/createObserver.js
// module id = 647
// module chunks = 0